import React, { useCallback } from 'react';
import { observer, calculatorState as store } from 'store';
import Button from 'components/UI/Button';
import MobileHeader from './MobileHeader';
import MobileSection from './MobileSection';
import { useTrans } from 'utils/localisation';
import * as styles from './MobileCalculator.module.scss';

function MobileCalculator({ id, sections, total }) {
  const { toggleModal, getTotalTeam, getCalculatorActivity } = store;
  const totalInfo = getTotalTeam(id);
  const isCalculatorActive = getCalculatorActivity(id);
  const t = useTrans(['calculator']);

  const onShowModal = useCallback(() => toggleModal(id, true), [toggleModal]);

  return (
    <div className={styles.wrapper}>
      <MobileHeader calculatorID={id} totalInfo={totalInfo} total={total} />
      <div>
        {sections.map(props => (
          <MobileSection key={props.name} calculatorID={id} {...props} />
        ))}
      </div>
      <div className={styles.send}>
        <Button className={styles.sendButton} onClick={onShowModal} disabled={!isCalculatorActive}>
          {t('getPrice')}
        </Button>
      </div>
    </div>
  );
}

export default observer(MobileCalculator);
